function getTextComponentRoot(componentRef, selectorAttribute) {
  if (!componentRef) {
    return "";
  }

  // extract reference to the textual content by navigating up to the component
  // wrapper node, and then finding the ".gText__expanded" container inside
  let componentWrapper = componentRef;
  while (componentWrapper && !componentWrapper.hasAttribute(selectorAttribute)) {
    componentWrapper = componentWrapper.parentElement;
  }
  return componentWrapper;
}

export { getTextComponentRoot };
//# sourceMappingURL=getTextComponentRoot.js.map
